(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["ferro-cliente"] = factory();
	else
		root["ferro-cliente"] = factory();
})(globalThis, () => {
return 